import type { Omittable } from "@salestrak/ui";

import { NameFormDialog } from "./name-form-dialog";

type IssueSourceFormDialogProps = Omittable<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (name: string) => Promise<void>;
  initialName?: string;
}>;

/** Create or edit one lead source — a name and nothing else. */
export function IssueSourceFormDialog({
  open,
  onOpenChange,
  onSubmit,
  initialName,
}: IssueSourceFormDialogProps) {
  const isEdit = initialName != null;
  return (
    <NameFormDialog
      open={open}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
      initialName={initialName}
      title={isEdit ? "Edit source" : "Create source"}
      description={isEdit ? "Update the source name." : "Add a new lead source."}
      placeholder="Source name"
      primaryLabel={isEdit ? "Save" : "Create"}
    />
  );
}
